export default function FormError({ text, ...props }) {
  return (
    <p {...props} className={`${props.className} text-red-600`}>
      {text}
    </p>
  );
}
